/**
 * Deterministycznie wyciaga pathname z URL'a backendu dla `<Link>`.
 * Zwraca `null` dla URL'i wymagajacych natywnego `<a>` (inny protokol / parse fail).
 *
 * Backend Imperial czasami zwraca pelne URL-e (http/https + host), a czasami
 * relatywne pathname'y. Next.js `<Link>` wspiera tylko pathname'y - dla pelnych
 * URL-i wracamy null i caller renderuje `<a>`.
 */
export function extractInternalHref(rawUrl: string): string | null {
  if (!rawUrl) return null;
  if (rawUrl.startsWith("/")) return rawUrl;
  try {
    const parsed = new URL(rawUrl);
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return null;
    return parsed.pathname + parsed.search + parsed.hash;
  } catch {
    return null;
  }
}
